export default {
  // Navigation
  home: 'Home',
  solutions: 'Solutions',
  sectors: 'Sectors',
  ecosystem: 'Ecosystem',
  about: 'About',
  recruitment: 'Recruitment',
  contact: 'Contact',

  // Hero Section
  heroHeadline: 'Transform Your Business with the Right Technology',
  heroSubheadline: 'Alpha Solutions integrates, deploys and supports ERP systems & business software for African companies — from audit to go-live, through to ongoing support.',
  requestConsultation: 'Request a Consultation',
  discoverSolutions: 'See Our Solutions',

  // What We Do Section
  whatWeDoTitle: 'Our Areas of Expertise',
  whatWeDoSubtitle: 'Complete technology solutions to digitize, automate, and control every aspect of your business.',
  businessSoftware: 'Business Software',
  businessSoftwareDesc: 'ERP, CRM, accounting, HR — management systems that centralize and drive your entire operation.',
  industrySoftware: 'Industry Software',
  industrySoftwareDesc: 'Hospitality, restaurant, retail, education, healthcare — solutions built for your industry.',
  automationDigitalization: 'Automation & Digitalization',
  automationDigitalizationDesc: 'Automate your processes, connect your systems, and manage your business with data.',
  smartInfrastructure: 'Smart Infrastructure & Security',
  smartInfrastructureDesc: 'CCTV, access control, biometrics and networks — protect and connect your business.',

  // Why Choose Us Section
  whyChooseTitle: 'What Sets Us Apart',
  whyChooseSubtitle: 'Not just a vendor — a true partner who understands your challenges and guides you to the right technology decisions.',
  solutionExpertise: 'Solution Expertise',
  solutionExpertiseDesc: 'Our team masters a wide range of technologies and knows how to identify the most suitable solution for every situation.',
  technologySelection: 'Technology Selection',
  technologySelectionDesc: 'We analyze the market to recommend the best-performing tools most suited to your industry.',
  reliableImplementation: 'Reliable Implementation',
  reliableImplementationDesc: 'Rigorous deployment, comprehensive testing, and guided go-live to ensure a smooth start.',
  trainingSupport: 'Training & Support',
  trainingSupportDesc: 'Full team training and 24/7 support so you get the most out of your investment.',

  // Technology Ecosystem Section
  techEcosystemTitle: 'World-Class Technology, Local Expertise',
  techEcosystemSubtitle: 'We partner with trusted software publishers and technology vendors to deliver proven solutions adapted to the African market.',
  techEcosystemDesc: 'Alpha Solutions leverages a solid network of global technology partners to offer you reliable, modern, and scalable systems — selected, integrated, and locally supported.',
  techEcosystemFeature1: 'Access to the best technologies available on the global market',
  techEcosystemFeature2: 'Systems proven by thousands of companies worldwide',
  techEcosystemFeature3: 'Solutions adapted to the realities and constraints of the African market',
  techEcosystemFeature4: 'Local French-language support with international expertise',

  // Industries Served Section
  industriesServedTitle: 'We Know Your Industry',
  industriesServedSubtitle: 'Solutions built for the operational realities of every industry, from hospitality to finance.',
  sectorNotListed: 'Your industry is not in the list?',
  discussProject: 'Discuss your project',

  // Sector names
  hotellerie: 'Hospitality',
  restauration: 'Restaurant',
  beaute: 'Beauty & Wellness',
  evenementiel: 'Events',
  immobilier: 'Real Estate',
  commerce: 'Retail & Commerce',
  production: 'Production',
  education: 'Education',
  sante: 'Health & Pharmacy',
  transport: 'Transport & Logistics',
  finance: 'Finance & Microfinance',
  administration: 'Administration',
  prestataireService: 'Service Providers',
  btpConstruction: 'BTP & Construction',
  rhPlacement: 'HR & Recruitment',
  cabinetsConseil: 'Consulting Firms',
  videoSurveillance: 'Video Surveillance',
  atelierGarage: 'Workshop & Garage',
  bulkSms: 'Bulk SMS & WhatsApp',

  // Call To Action Section
  ctaTitle: 'Let\'s Talk About Your Project',
  ctaSubtitle: 'Our experts are available to analyze your needs and recommend the best solutions — no commitment required.',
  ctaExpertTitle: 'Talk to an Expert',
  ctaExpertDesc: 'Get quick answers to your questions from our technology specialists.',
  ctaNeedsTitle: 'Share Your Needs',
  ctaNeedsDesc: 'Describe your operational challenges and we\'ll propose the right solutions.',
  ctaDemoTitle: 'Request a Demo',
  ctaDemoDesc: 'See our solutions in action with a personalized demonstration for your industry.',
  startConversation: 'Start a Conversation',
  callUs: 'Call Us',
  ctaAvailability: 'Available Monday to Saturday, 8:00 AM - 6:00 PM',
  contactExpert: 'Contact an Expert',
  shareNeeds: 'Share My Needs',

  // Solutions Menu
  erp: 'ERP',
  crm: 'CRM',
  accounting: 'Accounting',
  hr: 'Human Resources',

  // Footer
  footerDescription: 'Your trusted partner for digital transformation. We help African businesses adopt the best technologies available on the market to digitize operations, automate workflows, and control business activities.',
  ourServices: 'Our Services',
  usefulLinks: 'Useful Links',
  followUs: 'Follow Us',
  allRightsReserved: 'All rights reserved',
  erpSystems: 'ERP Systems',
  crmSystems: 'CRM Systems',
  accountingSoftware: 'Accounting Software',
  hrSoftware: 'HR Software',
  industrySpecific: 'Industry Solutions',
  technologyIntegration: 'Technology Integration',
  trustedAdvisor: 'Trusted Technology Advisor',
  digitalPartner: 'Digital Transformation Partner',
  solutionIntegrator: 'Solution Integrator',
  expertSupport: 'Expert Support',

  // Call to Actions
  talkToExpert: 'Talk to an Expert',
  requestDemo: 'Request a Demo',
  getStarted: 'Get Started',
  learnMore: 'Learn More',
  whatsappButton: 'Contact us on WhatsApp',

  // Contact Page
  contactPageTitle: 'Let\'s Discuss Your Project',
  contactPageSubtitle: 'Our team responds in under 2 hours. Choose the option that works best for you.',
  contactConsultationTitle: 'Request a Consultation',
  contactConsultationDesc: 'Discuss with our experts to analyze your needs and identify the best technology solutions for your business.',
  contactDemoTitle: 'Request a Demo',
  contactDemoDesc: 'Discover our solutions in action with a personalized demonstration tailored to your industry.',
  contactExpertTitle: 'Talk to an Expert',
  contactExpertDesc: 'Get quick answers to your technical or commercial questions from our specialists.',
  formFullName: 'Full Name',
  formCompany: 'Company',
  formSector: 'Industry Sector',
  formPhone: 'Phone/WhatsApp',
  formEmail: 'Email',
  formMessage: 'Your Message',
  formRequestType: 'Request Type',
  formSelectSector: 'Select your sector',
  formSelectRequest: 'Select request type',
  requestConsultationType: 'Strategic Consultation',
  requestDemoType: 'Solution Demo',
  requestQuoteType: 'Quote Request',
  requestSupportType: 'Technical Support',
  requestPartnershipType: 'Partnership',
  requestOtherType: 'Other',
  submitConsultation: 'Request a Consultation',
  submitDemo: 'Request a Demo',
  submitContact: 'Send Message',
  sending: 'Sending...',
  formSuccessTitle: 'Message sent successfully!',
  formSuccessMessage: 'We have received your request. Our team will contact you within 2 business hours.',
  formErrorTitle: 'Sending Error',
  formErrorMessage: 'An error occurred. Please try again or contact us directly by phone.',
  contactInfoTitle: 'Contact Information',
  contactInfoSubtitle: 'Multiple ways to reach us',
  whatsappLabel: 'WhatsApp',
  phoneLabel: 'Phone',
  locationLabel: 'Location',
  emailLabel: 'Email',
  locationAddress: 'Douala, Akwa - Cameroon',
  quickResponseTitle: 'Quick Response Guaranteed',
  quickResponseMessage: 'We commit to responding within 2 business hours',
  businessHoursTitle: 'Business Hours',
  businessHoursWeekdays: 'Monday - Friday: 8:00 AM - 6:00 PM',
  businessHoursSaturday: 'Saturday: 9:00 AM - 2:00 PM',
  businessHoursSunday: 'Sunday: Closed',
  whyContactTitle: 'Why Contact Us?',
  whyContact1: 'Recognized expertise for 8 years',
  whyContact2: 'Solutions tailored to your industry',
  whyContact3: 'Local support in French',
  whyContact4: 'Personalized support',

  // Ecosystem Page
  ecosystemHeroTitle: 'Alpha Solutions: The Bridge Between Technology and Africa',
  ecosystemHeroSubtitle: 'Alpha Solutions collaborates with trusted technology vendors, software publishers, and global partners to deliver the best solutions adapted to African businesses.',
  ecosystemHeroCTA1: 'Discover Our Partners',
  ecosystemHeroCTA2: 'Become a Partner',
  ecosystemPartnersTitle: 'A Network of Trusted Technology Partners',
  ecosystemPartnersSubtitle: 'We work with a global network of technology vendors and software publishers to deliver reliable and proven solutions.',
  ecosystemPartner1Title: 'Global Technology Vendors',
  ecosystemPartner1Desc: 'We collaborate with world-leading technology providers to access the most advanced and reliable systems on the market.',
  ecosystemPartner2Title: 'Software Publishers',
  ecosystemPartner2Desc: 'Partnerships with specialized software publishers in ERP, CRM, accounting, HR, and industry-specific management solutions.',
  ecosystemPartner3Title: 'Solution Providers',
  ecosystemPartner3Desc: 'Network of partners offering complementary solutions in automation, security, infrastructure, and cloud services.',
  ecosystemRoleTitle: 'Our Mission in This Ecosystem',
  ecosystemRoleSubtitle: 'Alpha Solutions acts as a bridge between global technologies and the needs of African businesses.',
  ecosystemRole1Title: 'Solution Integrator',
  ecosystemRole1Desc: 'We select, adapt, and integrate the best technologies to meet the specific needs of each business.',
  ecosystemRole1Feature1: 'In-depth business needs analysis',
  ecosystemRole1Feature2: 'Selection of the most suitable solutions',
  ecosystemRole1Feature3: 'Technical integration and configuration',
  ecosystemRole1Feature4: 'Testing and validation before deployment',
  ecosystemRole2Title: 'Deployment Partner',
  ecosystemRole2Desc: 'We ensure complete deployment of technology solutions with support, training, and ongoing assistance.',
  ecosystemRole2Feature1: 'Project planning and management',
  ecosystemRole2Feature2: 'On-site installation and configuration',
  ecosystemRole2Feature3: 'Comprehensive user training',
  ecosystemRole2Feature4: 'Technical support and maintenance',
  ecosystemRole3Title: 'Technology Advisor',
  ecosystemRole3Desc: 'We guide businesses in their technology choices by recommending the most relevant solutions for their context.',
  ecosystemRole3Feature1: 'Technology audit and diagnosis',
  ecosystemRole3Feature2: 'Strategic recommendations',
  ecosystemRole3Feature3: 'Technology watch and innovation',
  ecosystemRole3Feature4: 'Digital transformation support',
  ecosystemBenefitsTitle: 'Why Work with Our Ecosystem',
  ecosystemBenefitsSubtitle: 'The advantages of our collaborative approach and our network of technology partners.',
  ecosystemBenefit1Title: 'Proven Solutions',
  ecosystemBenefit1Desc: 'Access to technologies tested and validated by thousands of businesses worldwide.',
  ecosystemBenefit2Title: 'Local Expertise',
  ecosystemBenefit2Desc: 'Adaptation of global solutions to the realities and constraints of the African market.',
  ecosystemBenefit3Title: 'Ongoing Support',
  ecosystemBenefit3Desc: 'Local technical assistance in French and long-term support.',
  ecosystemBenefit4Title: 'Guaranteed Evolution',
  ecosystemBenefit4Desc: 'Regular updates and access to new features of the solutions.',
  ecosystemValuesTitle: 'Our Partnership Values',
  ecosystemValuesSubtitle: 'The principles that guide our collaborations with technology vendors and our clients.',
  ecosystemValue1Title: 'Transparent Collaboration',
  ecosystemValue1Desc: 'Open and honest communication with our technology partners and clients to ensure the success of every project.',
  ecosystemValue2Title: 'Technical Excellence',
  ecosystemValue2Desc: 'Commitment to maintaining the highest quality standards in the selection, integration, and deployment of solutions.',
  ecosystemValue3Title: 'Mutual Trust',
  ecosystemValue3Desc: 'Lasting relationships based on trust, commitment fulfillment, and shared value creation.',
  ecosystemValue4Title: 'Continuous Innovation',
  ecosystemValue4Desc: 'Constant search for new technologies and solutions to meet the evolving needs of businesses.',
  ecosystemCTATitle: 'Join Our Partner Network',
  ecosystemCTASubtitle: 'Are you a software publisher or technology vendor looking for a reliable local partner in Africa? Let\'s discuss how we can collaborate.',
  ecosystemCTAButton1: 'Contact Us',
  ecosystemCTAButton2: 'WhatsApp',

  // About Page
  aboutHeroTitle: 'Born in Africa, Built for Africa',
  aboutHeroSubtitle: 'Your trusted partner for navigating the complex world of enterprise technology and selecting the best solutions to accelerate your growth.',
  aboutWhoTitle: 'Who Are We?',
  aboutWhoP1: 'Alpha Solutions is much more than a software vendor. We are your trusted technology advisor and integration partner who helps you navigate the complex world of enterprise technology.',
  aboutWhoP2: 'Since 2018, we have been collaborating with trusted solution providers and recognized software publishers to select, adapt, and deploy the most effective systems for African businesses.',
  aboutWhoP3: 'Our expertise lies in our ability to understand your business needs, recommend the right technologies, and ensure their successful integration into your operational environment.',
  aboutMethodTitle: 'A Simple Method, Concrete Results',
  aboutMethodSubtitle: 'How we help businesses make the right technology choices',
  aboutStep1Title: '1. Understand',
  aboutStep1Desc: 'We deeply analyze your business processes, operational challenges, and growth objectives to identify your real needs.',
  aboutStep2Title: '2. Recommend',
  aboutStep2Desc: 'With our deep knowledge of the technology ecosystem, we select the most suitable solutions for your African context.',
  aboutStep3Title: '3. Integrate',
  aboutStep3Desc: 'We deploy, configure, and integrate the chosen systems with full support: training, support, and ongoing maintenance.',
  aboutDiffTitle: 'What Sets Us Apart',
  aboutDiff1Title: 'Access to the Best Technologies',
  aboutDiff1Desc: 'We work with globally recognized solution providers to offer you proven and reliable systems, adapted to the African market.',
  aboutDiff2Title: 'Deep Local Expertise',
  aboutDiff2Desc: '8 years of hands-on experience allow us to adapt international technologies to the specific realities and constraints of the African business environment.',
  aboutDiff3Title: 'Independent and Objective Advice',
  aboutDiff3Desc: 'Our priority is to recommend the most suitable solution for your needs, not to sell a specific product. Your success is our success.',
  aboutDiff4Title: 'End-to-End Support',
  aboutDiff4Desc: 'From selection to integration, through training and 24/7 support, we stay by your side at every step of your digital transformation.',
  aboutVisionTitle: 'Our Vision',
  aboutVisionP1: 'To be the reference technology partner in Central Africa, helping businesses navigate the complex world of enterprise technology and select solutions that truly accelerate their growth.',
  aboutVisionP2: 'We firmly believe that every African business deserves access to the best technologies available on the global market, adapted to its local context and supported with excellence.',
  aboutMissionTitle: 'Our Mission',
  aboutMissionP1: 'To simplify the digital transformation of African businesses by offering expert guidance in the selection, integration, and adoption of technologies that truly meet their needs.',
  aboutMission1: 'Guide businesses through their complex technology choices',
  aboutMission2: 'Collaborate with trusted solution providers',
  aboutMission3: 'Adapt global technologies to the African business environment',
  aboutMission4: 'Offer personalized support and exceptional 24/7 assistance',
  aboutHistoryTitle: '8 Years of Innovation Serving Africa',
  aboutHistorySubtitle: '8 years of continuous innovation serving African businesses',
  aboutHistory1Title: '2018 - The Beginning',
  aboutHistory1Desc: 'Co-founding of Alpha Solutions SARL in Douala by Kevin Mbadjoun and Patrick Boujeka with a clear vision: help Cameroonian businesses access the best management technologies.',
  aboutHistory2Title: '2020-2022 - Expansion',
  aboutHistory2Desc: 'Development of our technology partner network and expansion of our multi-sector expertise: hospitality, beauty, retail, events, education, healthcare.',
  aboutHistory3Title: '2023-2025 - Leadership',
  aboutHistory3Desc: '750+ satisfied client companies, recognized leader in technology solution integration in Cameroon with expansion toward Central Africa.',
  aboutValuesTitle: 'What We Believe In',
  aboutValuesSubtitle: 'The principles that guide our daily actions in service of our clients',
  aboutValue1: 'Trust',
  aboutValue1Desc: 'We build lasting relationships based on transparency and integrity',
  aboutValue2: 'Client Proximity',
  aboutValue2Desc: '24/7 support, full training, personalized support at every step',
  aboutValue3: 'Expertise',
  aboutValue3Desc: 'Deep knowledge of technologies and the African market',
  aboutValue4: 'Excellence',
  aboutValue4Desc: 'We strive for excellence in every solution delivered, every support provided',
  aboutTeamTitle: 'Our Team',
  aboutTeamSubtitle: 'A solid and experienced team your business can count on',
  aboutCofoundersTitle: 'Co-Founders',
  aboutKevinRole: 'Co-Founder & CEO',
  aboutKevinDesc: 'Company visionary, Kevin drives the strategy and development of Alpha Solutions with over 10 years of experience in enterprise solutions.',
  aboutPatrickRole: 'Co-Founder',
  aboutPatrickDesc: 'Co-founder of Alpha Solutions in 2018 alongside Kevin Mbadjoun, Patrick brings his technical expertise and strategic vision to the company\'s development.',
  aboutDeptTitle: 'Our Operational Departments',
  aboutDept1: 'Operations & Solutions',
  aboutDept1Desc: 'System integration experts, configuration, and technical support. 24/7 client support and solution deployment.',
  aboutDept2: 'Consulting & Sales',
  aboutDept2Desc: 'Expert technology consultants guiding our 750+ client companies in their solution choices.',
  aboutDept3: 'Communication & Marketing',
  aboutDept3Desc: 'Communication and digital marketing professionals. Technology solution promotion strategies.',
  aboutDept4: 'Research & Innovation',
  aboutDept4Desc: 'Constantly listening to client requests and searching for new solutions to better serve our clientele.',
  aboutEnvTitle: 'A Solid Environment for Your Success',
  aboutEnvDesc: 'Our multidisciplinary team forms a solid and reliable environment your business can count on for its digital transformation.',
  aboutStatsTitle: 'Alpha Solutions in Numbers',
  aboutStatsSubtitle: 'Results that speak to our expertise and the trust of our clients',
  aboutStat1: 'Satisfied Client Companies',
  aboutStat2: 'Years of Experience',
  aboutStat3: 'Qualified Leads/Year',
  aboutStat4: 'Client Support',
  aboutWhyTitle: 'Why 750+ Companies Chose Us?',
  aboutWhySubtitle: 'Our satisfied clients speak to our difference',
  aboutWhy1Title: 'Recognized Sector Expertise',
  aboutWhy1Desc: '8 years of experience in every sector with solutions proven by our 750+ satisfied clients.',
  aboutWhy2Title: 'Exceptional Customer Service',
  aboutWhy2Desc: 'Full team training, 24/7 support, proactive maintenance. We stay by your side after installation.',
  aboutWhy3Title: 'Solutions Tailored to Your Needs',
  aboutWhy3Desc: 'Every solution is selected and adapted to your specific business processes. We recommend what truly works.',
  aboutWhy4Title: 'African Vision, International Standards',
  aboutWhy4Desc: 'Based in Douala, we understand the African market while giving you access to the best global technologies.',
  aboutCTATitle: 'Join Our 750+ Satisfied Client Companies',
  aboutCTASubtitle: 'Discover how we can help you navigate the technology world and select solutions that accelerate your growth',
  aboutCTAContact: 'Contact Us',
  aboutCTASolutions: 'Discover Our Solutions',

  // Pricing
  pricingBadge: 'Our Packages',
  pricingTitle: 'Packages adapted to your size',
  pricingSubtitle: 'Whatever your industry, we have a formula that fits your needs and budget.',
  pricingTariff: 'Pricing',
  pricingOnQuote: 'Custom quote',
  pricingAdapted: 'Adapted to your sector & size',
  pricingCTA: 'Request a quote',
  pricingNote: 'All packages include annual maintenance + after-sales service. Each sector has its own pricing — contact us for a custom quote.',
  pricingMostPopular: 'Most popular',
  pricingPack1Name: 'Essential',
  pricingPack1Tagline: 'To start efficiently',
  pricingPack1Target: 'Small businesses & independents',
  pricingPack2Name: 'Growth',
  pricingPack2Tagline: 'For expanding businesses',
  pricingPack2Target: 'SMEs & growing organizations',
  pricingPack3Name: 'Expert',
  pricingPack3Tagline: 'For large organizations',
  pricingPack3Target: 'Large enterprises & multi-sites',

  // Hero hardcoded
  heroBadge: 'ERP Integrator & Digital Partner',
  heroTrustLabel: 'They trust us',
  heroTrustMore: '+ 994 others',
  heroBookRDV: 'Book an Appointment',

  // References
  refTitle: '1,000+ businesses supported since 2018',
  refSubtitle: 'Companies from all sectors trust us for their digital transformation across Central Africa.',
  refTestimonialsTitle: 'Client testimonials by sector',
  refClientsTitle: 'Our partner companies',
  refPartnersTitle: 'Our technology partners',
  refTrustBadge: 'They trust us',
  refPartnerCTA: 'Building a solution?',
  refPartnerCTASub: 'Offer it to our 1,000+ clients →',

  // Solutions Grid
  solutionsGridTitle: 'Everything your business needs, under one roof',
  solutionsGridSubtitle: 'Integrated solutions deployed by our experts — from the initial audit to ongoing support.',
  solutionsGridCTA: 'Request a free demo',

  // Sector pages common
  sectorDemoBtn: 'Request a Demo',
  sectorFreeDemo: 'Request a Free Demo',
  sectorViewSolutions: 'See all our solutions',
  sectorWhyChoose: 'Why Choose Our Solutions?',

  // Methodology section
  methodologyBadge: 'Our Method',
  methodologyTitle: 'From audit to support — we never let go',
  methodologySubtitle: 'A structured 6-step approach to guarantee the success of your project, from A to Z.',
  methodologyStep1Title: 'Audit & Scoping',
  methodologyStep1Desc: 'Analysis of your business processes, identification of needs and definition of the project scope.',
  methodologyStep2Title: 'Configuration',
  methodologyStep2Desc: 'Software configuration according to your specifications: workflows, users, access rights, modules.',
  methodologyStep3Title: 'Data Migration',
  methodologyStep3Desc: 'Secure migration of your existing data (Excel, old software) to the new system.',
  methodologyStep4Title: 'Training',
  methodologyStep4Desc: 'Complete on-site training of your teams in French, tailored to each user profile.',
  methodologyStep5Title: 'Pilot Phase',
  methodologyStep5Desc: 'Go-live in real conditions with reinforced support to validate each process.',
  methodologyStep6Title: 'Deployment & Support',
  methodologyStep6Desc: 'Full go-live + annual maintenance + reactive local after-sales service.',
  methodologyCTA: 'Start my project',

  // StatsBar
  stat1Label: 'Businesses supported',
  stat1Sub: 'Since 2018',
  stat2Label: 'Active ERP clients',
  stat2Sub: 'Software & solutions',
  stat3Label: 'SMS campaigns executed',
  stat3Sub: 'Communication',
  stat4Label: 'ERPs connected via API',
  stat4Sub: 'Technology integration',
  stat5Label: 'Sectors of expertise',
  stat5Sub: 'Industries & trades',

  // CallToAction hardcoded
  ctaBookTitle: 'Book an Appointment',
  ctaBookDesc: 'Reserve a time slot with one of our sales reps for a dedicated meeting about your project.',
  ctaBookBtn: 'Book my slot',
  ctaBookBtnMain: 'Book an Appointment',

  // SolutionsGrid hardcoded solution titles & descriptions
  solErpTitle: 'ERP & Business Management',
  solErpDesc: 'Sector-specific ERP systems, complete integration of your management processes.',
  solPosTitle: 'POS & Retail',
  solPosDesc: 'Smart registers, real-time inventory management, automated invoicing.',
  solCrmTitle: 'CRM & Sales',
  solCrmDesc: 'Client relationship, sales pipelines, quotes, invoicing, and automatic follow-ups.',
  solSmsTitle: 'Bulk SMS & WhatsApp',
  solSmsDesc: 'Mass campaigns, WhatsApp Business API, OTP, alerts and digital marketing.',
  solCctvTitle: 'CCTV & Smart Building',
  solCctvDesc: 'Smart surveillance, biometrics, access control, and building automation.',
  solChatTitle: 'Chatbots & Automation',
  solChatDesc: 'WhatsApp/web chatbots, custom API integrations, and workflow automation.',
  solInfraTitle: 'Infrastructure & Networks',
  solInfraDesc: 'Business networks, servers, cloud, firewall, and IT security.',
  solPayTitle: 'Payments & Fintech',
  solPayDesc: 'MTN Money, Orange Money, Wave, online payments, and bank reconciliation.',
  solWebTitle: 'Development & Websites',
  solWebDesc: 'Professional websites, iOS/Android apps, and custom development.',

  // Solutions page
  solutionsPageBadge: 'Professional Software Solutions',
  solutionsPageTitle: 'Our Software Solutions',
  solutionsPageSubtitle: 'Discover our complete range of technology solutions tailored to your industry',
  solutionsPageDemoBtn: 'Request a Demo',
  solutionsPageFilterTitle: 'Filter by sector',
  solutionsPageAllSectors: 'All sectors',
  solutionsPageNotListed: 'Your sector is not listed?',
  solutionsPageNotListedDesc: 'We develop custom solutions for all industries. Contact us to discuss your specific needs.',
  solutionsPageCustomBtn: 'Request a custom solution',
  solutionsPageWriteBtn: 'Email us',
  solutionsPageReadyTitle: 'Ready to Transform Your Business?',
  solutionsPageReadyDesc: 'Join the 750+ satisfied client companies that trust us for their digital transformation',
  solutionsPageFreeDemoBtn: 'Request a Free Demo',
  solutionsPageAboutBtn: 'Learn more about us',
  howWeHelpTitle: 'How Alpha Solutions Helps You Choose the Right System',
  howWeHelpSubtitle: 'Our consulting and integration approach guarantees the success of your digital transformation',
  howWeHelpStep1: '1. Analyze Your Needs',
  howWeHelpStep1Desc: 'We deeply study your business processes and identify your specific needs',
  howWeHelpStep2: '2. Expert Recommendation',
  howWeHelpStep2Desc: 'We advise you on the best technology solutions adapted to your context',
  howWeHelpStep3: '3. Integration & Deployment',
  howWeHelpStep3Desc: 'We configure and deploy systems while respecting your operational constraints',
  howWeHelpStep4: '4. Training & Support',
  howWeHelpStep4Desc: 'We train your teams and provide continuous support to ensure your success',
  talkToExpertBtn: 'Talk to an Expert',
  solutionsSectorTitle: 'Industry Sectors',
  solutionsSectorSubtitle: 'Discover our specialized solutions by sector with testimonials from our satisfied clients',
  solutionsBySectorTitle: 'Software Solutions by Sector',
  solutionsBySectorSubtitle: 'Specialized systems adapted to the specific needs of each industry',
  solutionDetailBtn: 'See details',
  solutionContactBtn: 'Contact an expert',
  solutionContactUs: 'Contact us',
  solutionFeaturedBadge: 'FLAGSHIP PRODUCT',
  solutionCompleteBadge: 'COMPLETE SOLUTION',
  solutionViewDetails: 'See details',
  solutionRequestDemo: 'Request a demo',

  // ERP page
  erpPageBadge: 'COMPLETE SOLUTION',
  erpPageTitle: 'ERP - Integrated Solution',
  erpPageSubtitle: 'Our flagship ERP solution that transforms business management with 20+ integrated modules',
  erpPageDemoBtn: 'Request a Demo',
  erpPageTestimonialBtn: 'See Client Testimonial',
  erpPageTabFeatures: 'Features',
  erpPageTabAdvantages: 'Our Advantages',
  erpPageTabTestimonial: 'Satisfied Client',
  erpPageFeaturesTitle: '20+ Integrated Modules',
  erpPageFeaturesSubtitle: 'A complete solution covering all aspects of your business',
  erpPageCustomBadge: '100% Customizable to your needs',
  erpPageAdvantagesTitle: 'Why Choose Our ERP?',
  erpPageAdvantagesSubtitle: '8 years of experience serving 750+ satisfied businesses',
  erpPageTestimonialTitle: 'Satisfied Client',
  erpPageTestimonialSubtitle: 'Discover how our ERP transformed their business',
  erpPageReadyTitle: 'Ready to Transform Your Business?',
  erpPageReadyDesc: 'Join the 750+ companies that trust us for their digital transformation',
  erpPageFreeDemoBtn: 'Request a Free Demo',
  erpPageAllSolutionsBtn: 'See All Our Solutions',

  // Recruitment
  recruitmentRedirectTitle: 'Redirecting to our recruitment portal',
  recruitmentRedirectDesc: 'You will be automatically redirected to our recruitment platform.',
  recruitmentPortalBtn: 'Access the recruitment portal',
  recruitmentRedirectNote: 'If the redirect does not work, click the button above',

  // Positioning Section
  positioningTitle: 'Not a reseller — a true business partner',
  positioningSubtitle: 'Discover what fundamentally sets us apart from a simple software reseller.',
  positioningResellerTitle: 'Simple reseller',
  positioningPartnerTitle: 'Our complete approach',
  positioningReseller1: 'License sales, one-time transaction',
  positioningReseller2: 'No knowledge of your business',
  positioningReseller3: 'Limited follow-up after the sale',
  positioningReseller4: 'No training included',
  positioningReseller5: 'Unresponsive support',
  positioningPartner1: 'Technical integration & strategic consulting',
  positioningPartner2: 'Speaks the language of your industry',
  positioningPartner3: 'Continuous personalized support',
  positioningPartner4: 'Complete training for your teams',
  positioningPartner5: 'Reactive local support, in French',
  positioningBanner: 'Our strength: Understand your business + Master technologies + Deploy + Train + Ongoing support',

  // SectorsNew Section
  sectorsNewBadge: 'Sector Expertise',
  sectorsNewTitle: 'We know your industry',
  sectorsNewSubtitle: 'ERP and business software solutions tailored to each industry, deployed by experts who speak your language.',
  sectorsNewNotListed: 'Your sector is not in the list?',
  sectorsNewNotListedSub: 'We develop custom solutions for any type of business.',
  sectorsNewCTA: 'Let\'s discuss your project',
  sectorLogistique: 'Logistics & Transport',
  sectorLogistiqueSub: 'Shipments, fleet, fuel, freight forwarders',
  sectorBTPSub: 'Construction sites, subcontractors, equipment',
  sectorRHSub: 'Payroll, recruitment, talent management',
  sectorImmobilierSub: 'Properties, contracts, tenants, syndic',
  sectorProductionSub: 'Planning, quality, maintenance',
  sectorCommerceSub: 'Stock, sales, suppliers, checkout',
  sectorAtelierSub: 'Repair orders, parts, quotes',
  sectorCabinetsSub: 'Files, invoicing, assignments',
  sectorHotellerieRestaurationSub: 'PMS, POS, reservations, deliveries',
  sectorBeauteSub: 'Appointments, loyalty, spa, salon',
  sectorEvenementielSub: 'Ticketing, access control, payments',
  sectorSanteSub: 'Patients, appointments, drug inventory',
  sectorEducationSub: 'Students, grades, scheduling, fees',
  sectorFinanceSub: 'Portfolio, compliance, reporting',
  sectorPrestataireServiceSub: 'Assignments, invoicing, projects',

  // Contact Section
  contactSectionBadge: 'Contact',
  contactSectionTitle: 'Let\'s talk about your project',
  contactSectionSubtitle: 'Our team responds within 24 hours and offers a free consultation to analyze your needs.',
  contactCoords: 'Our contact details',
  contactPhoneWa: 'Phone / WhatsApp',
  contactAddress: 'Address',
  contactHours: 'Business Hours',
  contactHoursValue: 'Mon–Fri 8am–6pm',
  contactHoursSatValue: 'Sat 9am–2pm',
  contactWhatsappTitle: 'Quick response guaranteed',
  contactWhatsappDesc: 'Prefer WhatsApp for an immediate response from our sales team.',
  contactWhatsappBtn: 'Message on WhatsApp',
  contactWhyTitle: 'Why contact us?',
  contactWhy1: 'Free consultation, no commitment',
  contactWhy2: 'Response within 24 business hours',
  contactWhy3: 'Industry experts available',
  contactWhy4: 'Custom quote tailored to your business',
  contactMeetingTitle: 'Prefer a meeting?',
  contactMeetingDesc: 'Book a time slot directly with one of our sales reps. Online or in-person meeting in Douala.',
  contactMeetingBtn: 'Book an appointment →',
  contactFormTitle: 'Send a request',
  contactFormNameLabel: 'Full name *',
  contactFormNamePlaceholder: 'John Smith',
  contactFormCompanyLabel: 'Company *',
  contactFormCompanyPlaceholder: 'Your company name',
  contactFormPhoneLabel: 'Phone / WhatsApp *',
  contactFormPhonePlaceholder: '+237 6XX XXX XXX',
  contactFormEmailLabel: 'Email',
  contactFormEmailPlaceholder: 'your@email.com',
  contactFormSectorLabel: 'Industry sector *',
  contactFormSectorPlaceholder: 'Select your sector',
  contactFormRequestLabel: 'Request type',
  contactFormRequestPlaceholder: 'Select type',
  contactFormMessageLabel: 'Message',
  contactFormMessagePlaceholder: 'Briefly describe your needs and objectives...',
  contactFormCharsLeft: 'characters',
  contactFormSubmit: 'Send my request',
  contactFormSubmitting: 'Sending...',
  contactFormSuccessTitle: 'Request sent!',
  contactFormSuccessDesc: 'Our team will contact you within 24 business hours.',
  contactFormSuccessBtn: 'Send another request',
  contactFormErrorMsg: 'An error occurred. Please try again or contact us directly.',

  // Sector pages - common extended
  sectorAnalyzeNeeds: 'Analyze your needs',
  sectorAnalyzeNeedsDesc: 'We study your business to understand your specific challenges and goals.',
  sectorExpertReco: 'Expert recommendation',
  sectorExpertRecoDesc: 'We select the best systems tailored to your type of business and budget.',
  sectorIntegration: 'Integration & deployment',
  sectorIntegrationDesc: 'Full installation, custom configuration, and data migration.',
  sectorFormationSupport: 'Training & support',
  sectorFormationSupportDesc: 'Training your teams and ongoing assistance to ensure your success.',
  sectorHowWeHelp: 'How Alpha Solutions Helps You',
  sectorCustomizable: 'Customizable solutions for your type of business',
  sectorSatisfiedSince: 'Satisfied client since',
  tabFonctionnalites: 'Detailed Features',
  tabAvantages: 'What we bring',
  tabTemoignage: 'Satisfied Client',

  // Hotellerie sector
  hotellerieSectorHeroTitle: 'Hotel Management Solutions',
  hotellerieSectorHeroDesc: 'Complete systems to transform your establishment: PMS, reservations, billing, revenue management, and digital guest service.',
  hotellerieFeaturesTitle: 'Complete Features for Hospitality',
  hotellerieFeaturesSubtitle: 'Alpha Solutions integrates proven hotel management systems adapted to the African market',
  hotellerieFeaturesCustom: 'Customizable solutions for your type of establishment',
  hotellerieCtaTitle: 'Ready to transform your hotel?',
  hotellerieCtaDesc: 'Join our satisfied clients. Request your personalized demo.',
  hotellerieAvantagesTitle: 'What we bring you',
  hotellerieAvantagesSubtitle: 'Our 8 years of expertise in hospitality to transform your establishment',

  // Restauration sector
  restaurationHeroTitle: 'Restaurant Management Solutions',
  restaurationHeroDesc: 'Complete systems to optimize your restaurant: POS, order management, stock control, and much more',
  restaurationFeaturesTitle: 'Complete Features for Restaurants',
  restaurationFeaturesSubtitle: 'Alpha Solutions integrates proven restaurant management systems adapted to the African market',
  restaurationAvantagesTitle: 'What we bring to your restaurant',
  restaurationAvantagesSubtitle: 'Transform your restaurant with our 8 years of experience in solution integration',
  restaurationCtaTitle: 'Transform Your Restaurant Today',
  restaurationCtaDesc: 'Join the restaurateurs who increased their revenue by 30% with our integrated solutions',
  restaurationDemoBtn: 'Request a Free Demo',
  restaurationAllSolutions: 'See All Our Solutions',
  restaurationTestimonialBtn: 'See Client Testimonial',

  // Evenementiel sector
  evenementielHeroTitle: 'Events Solutions',
  evenementielHeroDesc: 'Specialists in payment security for large public events. Online ticketing, access control, and complete management.',
  evenementielSpecialite: 'Our Specialty: Payment Security',
  evenementielSpecialiteDesc: 'We are highly sought after for providing payment security solutions for large public events such as SUNDAYZ, White Bloom, Coco Beach',
  evenementielFeaturesTitle: 'Complete Solution for Events',
  evenementielFeaturesSubtitle: 'Over 16 specialized features to manage your events from A to Z, with special attention to payment security.',
  evenementielAvantagesTitle: 'What we bring you',
  evenementielAvantagesSubtitle: 'Our 8 years of expertise in events to secure your events',
  evenementielCtaTitle: 'Ready to secure your events?',
  evenementielCtaDesc: 'Join SUNDAYZ and our other clients. Organize your events with complete peace of mind.',
  evenementielSecureBtn: 'Secure My Event',
  evenementielAllSolutions: 'All our Solutions',
  evenementielDemoBtn: 'Request a demo',
  evenementielConsultBtn: 'Request a consultation',
  evenementielDiscoverBtn: 'Discover our solutions',

  // Footer hardcoded
  footerTagline: 'ERP Integrator & Digital Partner',
  footerAddress: '822 rue Joffre, Akwa — Douala, Cameroon',
  footerCopyright: '© 2026 Alpha Solutions — ERP Integrator & Digital Partner.',

  // References - Testimonials
  refTestimonial1Quote: 'Integrated reservation system and optimized client management for our complex. Alpha Solutions transformed the way we work.',
  refTestimonial2Quote: 'Fast POS installation — optimized orders and exceptional customer service. We can\'t live without it.',
  refTestimonial3Quote: 'Complete spa management with personalized client tracking and optimized appointment scheduling. Our teams love the tool.',
  refTestimonial4Quote: 'Before the ERP we managed everything in Excel. Now we visualize profitability per vehicle in real time.',
  refTestimonial5Quote: 'Automated tenant tracking, automatic reminders, centralized contracts. Indispensable.',
  refTestimonial6Quote: 'Revolutionized stock and sales management, real-time supplier tracking. ROI visible from the first month.',
  refSectorHotelRestauration: 'Hospitality & Restaurant',
  refSectorBeaute: 'Beauty & Wellness',
  refSectorLogistique: 'Logistics & Transport',
  refSectorProduction: 'Production & Industry',
  refSectorImmobilier: 'Real Estate',
  refSectorCommerce: 'Retail & Distribution',
  refAndManyMore: 'and many more',

  // Partners descriptions
  partnerCaviusDesc: 'ERP & business management solutions',
  partnerAwebstarDesc: 'Web & digital development',
  partnerRedsparkDesc: 'Payment & fintech solutions',
  partnerPaymeDesc: 'Mobile & digital payments',
  partnerDigiticaDesc: 'Digital transformation & automation',
  partnerAtlantaDesc: 'Infrastructure & IT',
  partnerKaeyrosDesc: 'Analytics & business intelligence',

  // About page - hardcoded section
  aboutExpertiseSectionTitle: 'Our Expertise',
  aboutExpertiseSectionSubtitle: '8 years of experience driving digital transformation for businesses',
  aboutExpertise1Title: 'Solution Integration',
  aboutExpertise1Desc: 'Selection and integration of ERP, CRM, accounting systems tailored to your needs',
  aboutExpertise2Title: '24/7 Support',
  aboutExpertise2Desc: 'Permanent technical assistance and ongoing training for your teams',
  aboutExpertise3Title: 'Technology Consulting',
  aboutExpertise3Desc: 'Expert guidance for navigating the complex world of technologies',
  aboutExpertise4Title: 'Local Adaptation',
  aboutExpertise4Desc: 'Global technologies adapted to the African business environment',
  aboutStatsSection2Title: 'Alpha Solutions in Numbers',
  aboutStatsSection2Subtitle: 'Results that speak to our expertise and client trust',
  aboutStatsSection2Desc: '750+ companies trust us',
  aboutStatsSection2SubDesc: 'From SMEs to large enterprises, our clients testify to our expertise and our commitment to their growth.',

  // Solutions page - hardcoded sections
  solErpSystemsTitle: 'ERP Systems',
  solErpSystemsDesc: 'Centralize and optimize all operations of your business with an integrated ERP system',
  solErpDiscover: 'Discover our ERP solution',
  solCrmSystemsTitle: 'CRM Systems',
  solCrmSystemsDesc: 'Transform your client relationships and boost your commercial performance',
  solCrmDiscover: 'Discover our CRM solution',
  solAccountingTitle: 'Accounting & Finance Systems',
  solAccountingDesc: 'Automate your accounting and get complete financial visibility',
  solHRTitle: 'HR & Payroll Systems',
  solHRDesc: 'Simplify HR management and automate payroll',
  solProjectTitle: 'Project Management Systems',
  solProjectDesc: 'Plan, track and control your projects to guarantee success',
  solRequestDemo: 'Request a demo',
  solCentralData: 'Data Centralization',
  solCentralDataDesc: 'All your business data in one unified system',
  solFinancialVis: 'Financial Visibility',
  solFinancialVisDesc: 'Real-time reporting for better decision making',
  solOpsControl: 'Operational Control',
  solOpsControlDesc: 'Master all your business processes',
  solBetterPlanning: 'Better Planning',
  solBetterPlanningDesc: 'Anticipate and plan your strategic activities',
  solClientRel: 'Client Relationship Management',
  solClientRelDesc: 'Centralize all client information',
  solSalesTrack: 'Sales Tracking',
  solSalesTrackDesc: 'Commercial pipeline and opportunities in real time',
  solCommHistory: 'Communication History',
  solCommHistoryDesc: 'All client interactions centralized',
  solMarkAnalysis: 'Marketing Analytics',
  solMarkAnalysisDesc: 'Insights and forecasts for your campaigns',
  solAutoAccounting: 'Automated Accounting',
  solAutoAccountingDesc: 'Automatic entry and bank reconciliation',
  solFinancialReport: 'Financial Reporting',
  solFinancialReportDesc: 'Instant and customizable financial statements',
  solCompliance: 'Regulatory Compliance',
  solComplianceDesc: 'Compliance with local accounting standards',
  solDashboards: 'Dashboards',
  solDashboardsDesc: 'Real-time financial indicators',
  solEmpMgmt: 'Employee Management',
  solEmpMgmtDesc: 'Complete files and staff history',
  solPayrollAuto: 'Payroll Automation',
  solPayrollAutoDesc: 'Automatic salary and payroll calculation',
  solAttendance: 'Attendance Tracking',
  solAttendanceDesc: 'Leave, absence and timekeeping management',
  solHRReport: 'HR Reporting',
  solHRReportDesc: 'Staff analytics and statistics',
  solPlanning: 'Planning',
  solPlanningDesc: 'Task and resource scheduling',
  solCostTrack: 'Cost Tracking',
  solCostTrackDesc: 'Budget control and expense analysis',
  solTeamCollab: 'Team Collaboration',
  solTeamCollabDesc: 'Communication and document sharing',
  solPerfMonitor: 'Performance Monitoring',
  solPerfMonitorDesc: 'Progress indicators and alerts',
  solHotelTitle: 'Hotel Management Software',
  solHotelDesc: 'Complete systems to manage all aspects of your hotel establishment, from PMS to guest services',
  solRetailTitle: 'Retail & POS Systems',
  solRetailDesc: 'Complete solutions to manage your points of sale, inventory, and optimize commercial operations',
  solSchoolTitle: 'School Management Software',
  solSchoolDesc: 'Complete systems to digitalize the management of your educational institution',
  solClinicTitle: 'Clinic & Pharmacy Systems',
  solClinicDesc: 'Complete solutions to digitalize the management of your healthcare facility',
  solServiceBizTitle: 'Software for Service Businesses',
  solServiceBizDesc: 'Complete solutions to manage your clients, projects, billing, and service operations',
  solSeeHotelDetails: 'See Hospitality details',
  solSeeRetailDetails: 'See Retail details',
  solSeeEduDetails: 'See Education details',
  solSeeHealthDetails: 'See Health details',
  solReservations: 'Reservations',
  solRoomMgmt: 'Room Management',
  solBilling: 'Billing',
  solGuestServices: 'Guest Services',
  solCashSystem: 'Point of Sale System',
  solStockTrack: 'Stock Tracking',
  solSalesAnalysis: 'Sales Analysis',
  solMultiStore: 'Multi-Store Management',
  solStudentFiles: 'Student Records',
  solAttendanceMgmt: 'Attendance Management',
  solGradingSystem: 'Grading System',
  solParentComm: 'Parent Communication',
  solPatientFiles: 'Patient Records',
  solPrescriptions: 'Prescription Management',
  solAppointments: 'Appointment Management',
  solPharmacyInv: 'Pharmacy Inventory',
  solClientMgmt: 'Client Management',
  solInvoicing: 'Invoicing',
  solTaskMgmt: 'Task Management',
  solProjectTrack: 'Project Tracking',
  solProductPhare: 'FLAGSHIP PRODUCT',
  solCompleteSolution: 'COMPLETE SOLUTION',

  // Solutions page - CRM cards (hardcoded)
  solCrmClientRel: 'Client Relationship Management',
  solCrmClientRelDesc: 'Centralize all client information',
  solCrmSalesTrack: 'Sales Tracking',
  solCrmSalesTrackDesc: 'Commercial pipeline and opportunities in real time',
  solCrmCommHistory: 'Communication History',
  solCrmCommHistoryDesc: 'All client interactions centralized',
  solCrmMarkAnalysis: 'Marketing Analytics',
  solCrmMarkAnalysisDesc: 'Insights and forecasts for your campaigns',

  // Solutions page - Accounting cards (hardcoded)
  solAccAutoAccounting: 'Automated Accounting',
  solAccAutoAccountingDesc: 'Automatic entry and bank reconciliation',
  solAccFinancialReport: 'Financial Reporting',
  solAccFinancialReportDesc: 'Instant and customizable financial statements',
  solAccCompliance: 'Regulatory Compliance',
  solAccComplianceDesc: 'Compliance with local accounting standards',
  solAccDashboards: 'Dashboards',
  solAccDashboardsDesc: 'Real-time financial indicators',
  solAccDemoBtn: 'Request a demo',

  // Solutions page - HR cards (hardcoded)
  solHrEmpMgmt: 'Employee Management',
  solHrEmpMgmtDesc: 'Complete files and staff history',
  solHrPayrollAuto: 'Payroll Automation',
  solHrPayrollAutoDesc: 'Automatic salary and payroll calculation',
  solHrAttendance: 'Attendance Tracking',
  solHrAttendanceDesc: 'Leave, absence and timekeeping management',
  solHrReporting: 'HR Reporting',
  solHrReportingDesc: 'Staff analytics and statistics',

  // Solutions page - Project Mgmt cards (hardcoded)
  solProjPlanning: 'Planning',
  solProjPlanningDesc: 'Task and resource scheduling',
  solProjCostTrack: 'Cost Tracking',
  solProjCostTrackDesc: 'Budget control and expense analysis',
  solProjTeamCollab: 'Team Collaboration',
  solProjTeamCollabDesc: 'Communication and document sharing',
  solProjPerfMonitor: 'Performance Monitoring',
  solProjPerfMonitorDesc: 'Progress indicators and alerts',

  // Solutions page - Hotel detail cards (hardcoded)
  solHotelReservationsTitle: 'Reservations',
  solHotelReservationsFeat1: 'Online reservation system',
  solHotelReservationsFeat2: 'Group and event management',
  solHotelReservationsFeat3: 'Automatic confirmations',
  solHotelReservationsFeat4: 'Multi-channel integration',
  solHotelRoomTitle: 'Room Management',
  solHotelRoomFeat1: 'Real-time status',
  solHotelRoomFeat2: 'Housekeeping coordination',
  solHotelRoomFeat3: 'Preventive maintenance',
  solHotelRoomFeat4: 'Category management',
  solHotelBillingTitle: 'Billing',
  solHotelBillingFeat1: 'Automatic billing',
  solHotelBillingFeat2: 'Extras management',
  solHotelBillingFeat3: 'Automatic tax calculation',
  solHotelBillingFeat4: 'Personalized invoices',
  solHotelGuestTitle: 'Guest Services',
  solHotelGuestFeat1: 'Integrated hotel CRM',
  solHotelGuestFeat2: 'Loyalty program',
  solHotelGuestFeat3: 'Client preferences',
  solHotelGuestFeat4: 'Stay history',

  // Solutions page - Retail detail cards (hardcoded)
  solRetailCashTitle: 'Point of Sale System',
  solRetailCashFeat1: 'Fast touchscreen interface',
  solRetailCashFeat2: 'Multiple payment methods',
  solRetailCashFeat3: 'Promotions management',
  solRetailCashFeat4: 'Loyalty program',
  solRetailStockTitle: 'Stock Tracking',
  solRetailStockFeat1: 'Real-time inventory',
  solRetailStockFeat2: 'Restock alerts',
  solRetailStockFeat3: 'Full traceability',
  solRetailStockFeat4: 'Batch management',
  solRetailSalesTitle: 'Sales Analytics',
  solRetailSalesFeat1: 'Detailed sales reports',
  solRetailSalesFeat2: 'Best-selling products',
  solRetailSalesFeat3: 'Profitability analysis',
  solRetailSalesFeat4: 'Sales forecasts',
  solRetailMultiTitle: 'Multi-Store Management',
  solRetailMultiFeat1: 'Consolidated view',
  solRetailMultiFeat2: 'Inter-store transfers',
  solRetailMultiFeat3: 'Centralized price management',
  solRetailMultiFeat4: 'Comparative reporting',

  // Solutions page - School detail cards (hardcoded)
  solSchoolStudentsTitle: 'Student Records',
  solSchoolStudentsFeat1: 'Complete database',
  solSchoolStudentsFeat2: 'Academic history',
  solSchoolStudentsFeat3: 'Personal information',
  solSchoolStudentsFeat4: 'Administrative documents',
  solSchoolAttTitle: 'Attendance Management',
  solSchoolAttFeat1: 'Electronic time tracking',
  solSchoolAttFeat2: 'Absence tracking',
  solSchoolAttFeat3: 'Automatic alerts',
  solSchoolAttFeat4: 'Attendance reports',
  solSchoolGradesTitle: 'Grading System',
  solSchoolGradesFeat1: 'Online grade entry',
  solSchoolGradesFeat2: 'Automatic average calculation',
  solSchoolGradesFeat3: 'Customizable report cards',
  solSchoolGradesFeat4: 'Progress tracking',
  solSchoolParentsTitle: 'Parent Communication',
  solSchoolParentsFeat1: 'Online parent portal',
  solSchoolParentsFeat2: 'Automatic notifications',
  solSchoolParentsFeat3: 'Integrated messaging',
  solSchoolParentsFeat4: 'Access to results',

  // Solutions page - Clinic detail cards (hardcoded)
  solClinicPatientsTitle: 'Patient Records',
  solClinicPatientsFeat1: 'Electronic medical records',
  solClinicPatientsFeat2: 'Complete medical history',
  solClinicPatientsFeat3: 'Security and confidentiality',
  solClinicPatientsFeat4: 'Quick access to information',
  solClinicPrescTitle: 'Prescription Management',
  solClinicPrescFeat1: 'Electronic prescriptions',
  solClinicPrescFeat2: 'Drug database',
  solClinicPrescFeat3: 'Interaction alerts',
  solClinicPrescFeat4: 'Prescription history',
  solClinicApptTitle: 'Appointment Management',
  solClinicApptFeat1: 'Online medical calendar',
  solClinicApptFeat2: 'Online booking',
  solClinicApptFeat3: 'Automatic reminders',
  solClinicApptFeat4: 'Waiting room management',
  solClinicPharmTitle: 'Pharmacy Inventory',
  solClinicPharmFeat1: 'Drug stock management',
  solClinicPharmFeat2: 'Expiry date tracking',
  solClinicPharmFeat3: 'Restock alerts',
  solClinicPharmFeat4: 'Complete traceability',

  // Solutions page - Service biz detail cards (hardcoded)
  solSvcClientTitle: 'Client Management',
  solSvcClientFeat1: 'Client database',
  solSvcClientFeat2: 'Interaction history',
  solSvcClientFeat3: 'Contract management',
  solSvcClientFeat4: 'Satisfaction tracking',
  solSvcBillingTitle: 'Invoicing',
  solSvcBillingFeat1: 'Automatic quotes and invoices',
  solSvcBillingFeat2: 'Recurring billing',
  solSvcBillingFeat3: 'Payment tracking',
  solSvcBillingFeat4: 'Automatic reminders',
  solSvcTaskTitle: 'Task Management',
  solSvcTaskFeat1: 'Intervention scheduling',
  solSvcTaskFeat2: 'Team assignment',
  solSvcTaskFeat3: 'Progress tracking',
  solSvcTaskFeat4: 'Automatic notifications',
  solSvcProjectTitle: 'Project Tracking',
  solSvcProjectFeat1: 'Client project management',
  solSvcProjectFeat2: 'Time spent tracking',
  solSvcProjectFeat3: 'Budget control',
  solSvcProjectFeat4: 'Profitability reports',
  solSvcDemoBtn: 'Request a demo',

  // Filter sector labels (solutions page)
  filterSectorHotellerie: 'Hospitality',
  filterSectorRestauration: 'Restaurant',
  filterSectorBeaute: 'Beauty & Wellness',
  filterSectorEvenementiel: 'Events',
  filterSectorImmobilier: 'Real Estate',
  filterSectorCommerce: 'Retail & Distribution',
  filterSectorProduction: 'Production & Industry',
  filterSectorEducation: 'Education',
  filterSectorSante: 'Health',
  filterSectorTransport: 'Transport & Logistics',
  filterSectorFinance: 'Financial Services',
  filterSectorAdministration: 'Public Administration',

  // CRM page
  crmPageTitle: 'CRM - Client Management',
  crmPageSubtitle: 'Optimize client relationships and boost your sales with our complete CRM solution',
  crmPageDemoBtn: 'Request a Demo',
  crmPageTestimonialBtn: 'See Client Testimonial',
  crmPageTabFeatures: 'Features',
  crmPageTabAdvantages: 'Our Advantages',
  crmPageTabTestimonial: 'Satisfied Client',
  crmPageFeaturesTitle: '15+ CRM Features',
  crmPageFeaturesSubtitle: 'A complete solution for optimizing client relationships',
  crmPageCustomBadge: '100% Customizable to your needs',
  crmPageAdvTitle: 'Why Choose Our CRM?',
  crmPageAdvSubtitle: 'Increase your sales by 40% with our expert support',
  crmPageTestiTitle: 'Satisfied Client',
  crmPageTestiSubtitle: 'Discover how our CRM boosted their sales performance',
  crmPageCTATitle: 'Boost Your Sales Today',
  crmPageCTASubtitle: 'Join the companies that increased their sales by 40% with our CRM',
  crmPageFreeDemoBtn: 'Request a Free Demo',
  crmPageAllSolutionsBtn: 'See All Our Solutions',
  crmAdv1Title: '+40% Sales',
  crmAdv1Desc: 'Average sales increase through pipeline optimization',
  crmAdv2Title: 'Time Savings',
  crmAdv2Desc: 'Automation of repetitive tasks, more time to sell',
  crmAdv3Title: 'Client Satisfaction',
  crmAdv3Desc: 'Improved client experience and stronger loyalty',
  crmAdv4Title: 'Full Mobility',
  crmAdv4Desc: 'Complete mobile access for your field teams',
  crmAdv5Title: 'Artificial Intelligence',
  crmAdv5Desc: 'Sales predictions and automatic recommendations',
  crmAdv6Title: 'Integrations',
  crmAdv6Desc: 'Connect with your existing tools (email, accounting, etc.)',
  crmTestiClientName: 'TelecomPlus Cameroun',
  crmTestiClientSector: 'Telecommunications - 150+ sales reps',
  crmTestiQuote: 'Since implementing the Alpha Solutions CRM, our sales teams have increased performance by 45%. The pipeline visibility and automated follow-ups have transformed our commercial approach. An investment paid back in 4 months!',
  crmTestiStat1Value: '+45%',
  crmTestiStat1Label: 'Sales increase',
  crmTestiStat2Value: '4 months',
  crmTestiStat2Label: 'Return on investment',
  crmTestiStat3Value: '92%',
  crmTestiStat3Label: 'Team satisfaction',
  crmTestiPersonName: 'Marie-Claire Nkomo',
  crmTestiPersonRole: 'Sales Director',

  // Header CTA button
  headerBookRdv: 'Book a Meeting',
  talkWithUs: 'Talk with us',

  // Sector pages - Beaute
  beauteHeroTitle: 'Beauty & Wellness Solutions',
  beauteHeroDesc: 'Transform your salon with our appointment management, client loyalty, gift cards, and automated marketing solutions.',
  beauteFeaturesTitle: 'Advanced Features for Beauty & Wellness',
  beauteFeaturesSubtitle: 'Over 18 specialized features to efficiently manage your salon, spa or beauty institute and maximize your revenue.',
  beauteCustomBadge: '100% customizable features for your type of establishment',
  beauteWeBringTitle: 'What we bring you',
  beauteWeBringSubtitle: 'Our 8 years of expertise in beauty to transform your salon',
  beauteTestiName: 'Dr Kamga',
  beauteTestiRole: 'Owner - Medispa',
  beauteTestiQuote: 'The Alpha Solutions solution revolutionized our medispa. Automated appointment management and personalized client tracking significantly improved our patients\' experience and optimized our scheduling.',
  beauteSatisfied: 'Satisfied client since 2022',
  beauteCtaTitle: 'Ready to transform your salon?',
  beauteCtaDesc: 'Join our satisfied clients and increase your revenue. Request your personalized demo.',
  beauteSol1: 'Increased client retention rate',
  beauteSol2: 'Optimized scheduling and reduced downtime',
  beauteSol3: 'Automated marketing campaigns',
  beauteSol4: 'Complete stock and product management',
  beauteSol5: 'Personalized loyalty program',
  beauteSol6: 'Detailed reporting to optimize performance',

  // Sector pages - Commerce
  commerceHeroTitle: 'Retail & Distribution Solutions',
  commerceHeroDesc: 'Complete systems to manage your commerce: inventory, sales, suppliers, e-commerce, and multi-store operations',
  commerceFeaturesTitle: 'Complete Features for Retail & Distribution',
  commerceFeaturesSubtitle: 'Alpha Solutions integrates proven commercial management systems adapted to the African market',
  commerceCustomBadge: 'Customizable solutions for your type of commerce',
  commerceWeBringTitle: 'What we bring to your commerce',
  commerceWeBringSubtitle: 'Transform your business with our 8 years of experience in solution integration',
  commerceTestiName: 'Gaby Mbomgnin',
  commerceTestiRole: 'Owner - MD Distribution',
  commerceTestiQuote: 'Thanks to Alpha Solutions, MD Distribution revolutionized its management. Real-time stock tracking and automated supplier management allowed us to optimize operations and increase revenue by 35%.',
  commerceSatisfied: 'Satisfied client since 2020',
  commerceCtaTitle: 'Ready to Optimize Your Commerce?',
  commerceCtaDesc: 'Join the companies that trust us for their digital transformation',
  commerceAdv1Title: 'Stock Optimization',
  commerceAdv1Desc: '30% reduction in stockouts and 25% in overstocking thanks to automatic alerts and forecasts',
  commerceAdv2Title: 'Sales Growth',
  commerceAdv2Desc: 'Average 25% revenue growth with our management systems and integrated e-commerce',
  commerceAdv3Title: 'Client Loyalty',
  commerceAdv3Desc: 'Integrated loyalty program to increase retention by 40% and repeat purchases',
  commerceAdv4Title: 'Time Savings',
  commerceAdv4Desc: 'Automation of repetitive tasks saving 15 hours per week',

  // Sector pages - Sante
  santeHeroTitle: 'Healthcare Solutions',
  santeHeroDesc: 'Modernize your healthcare facility with our medical management and patient record solutions',
  santeSolutionsTitle: 'Our Healthcare Solutions',
  santeSolutionsSubtitle: 'A complete platform for modern management of your healthcare facility',
  santeWhyTitle: 'Why Choose Our Solutions?',
  santeTestiName: 'Pharmacie de Gaulle',
  santeTestiRole: 'Health & Pharmacy',
  santeTestiQuote: 'Digitalizing our pharmacy with Alpha Solutions transformed our practice. Automated stock management, expiry tracking and prescription handling saved us precious time to better serve our patients.',
  santeSatisfied: 'Satisfied client since 2021',
  santeCtaTitle: 'Ready to Modernize Your Healthcare Facility?',
  santeCtaDesc: 'Join the healthcare professionals that trust us',
  santeAdv1Title: 'Maximum Security',
  santeAdv1Desc: 'GDPR compliance and medical data protection',
  santeAdv2Title: 'Efficiency +40%',
  santeAdv2Desc: 'Improved consultation efficiency',
  santeAdv3Title: 'Care Quality',
  santeAdv3Desc: 'Improved care quality through digitalization',
  santeAdv4Title: 'Patient Satisfaction',
  santeAdv4Desc: 'Better patient experience with digital services',

  // Sector pages - Education
  educationHeroTitle: 'Education Solutions',
  educationHeroDesc: 'Modernize your school with our student management and educational solutions',
  educationSolutionsTitle: 'Our Education Solutions',
  educationSolutionsSubtitle: 'A complete platform for modern management of your educational institution',
  educationWhyTitle: 'Why Choose Our Solutions?',
  educationTestiName: 'Groupe Scolaire Etoile',
  educationTestiRole: 'Educational Institution',
  educationTestiQuote: 'Digitalizing our school with Alpha Solutions revolutionized our management. Parents can now track their children\'s grades in real time, and our administration has become 100% digital.',
  educationSatisfied: 'Satisfied client since 2021',
  educationCtaTitle: 'Ready to Modernize Your Institution?',
  educationCtaDesc: 'Join the educational institutions that trust us',
  educationAdv1Title: 'Complete Digitalization',
  educationAdv1Desc: 'Digital transformation of all educational processes',
  educationAdv2Title: 'Time Savings',
  educationAdv2Desc: 'Automation of 70% of administrative tasks',
  educationAdv3Title: 'Personalized Tracking',
  educationAdv3Desc: 'Individualized support for each student',
  educationAdv4Title: 'Improved Communication',
  educationAdv4Desc: 'Better collaboration between all stakeholders',

  // Sector pages - Transport
  transportHeroTitle: 'Transport & Logistics Solutions',
  transportHeroDesc: 'Optimize your logistics chain with our fleet management and delivery optimization solutions',
  transportSolutionsTitle: 'Our Transport & Logistics Solutions',
  transportSolutionsSubtitle: 'A complete suite to optimize your logistics and transport chain',
  transportWhyTitle: 'Why Choose Our Solutions?',
  transportTestiName: 'AQUAVITA',
  transportTestiRole: 'Transport & Logistics',
  transportTestiQuote: 'Thanks to Alpha Solutions, we optimized our delivery routes and reduced transport costs by 30%. Real-time fleet tracking allows us to offer exceptional service to our clients.',
  transportSatisfied: 'Satisfied client since 2020',
  transportCtaTitle: 'Ready to Optimize Your Logistics?',
  transportCtaDesc: 'Join the transport companies that trust us',
  transportAdv1Title: 'Cost Reduction',
  transportAdv1Desc: '25% reduction in transport costs through optimization',
  transportAdv2Title: 'Efficiency +30%',
  transportAdv2Desc: 'Improved delivery efficiency',
  transportAdv3Title: 'Client Satisfaction',
  transportAdv3Desc: 'Improved satisfaction through real-time tracking',
  transportAdv4Title: 'Enhanced Security',
  transportAdv4Desc: 'Improved fleet and cargo security',

  // Sector pages - Finance
  financeHeroTitle: 'Financial Services Solutions',
  financeHeroDesc: 'Optimize your financial services with our portfolio management and regulatory compliance solutions',
  financeSolutionsTitle: 'Our Financial Services Solutions',
  financeSolutionsSubtitle: 'A complete platform for modern financial services management',
  financeWhyTitle: 'Why Choose Our Solutions?',
  financeTestiName: 'CN 237',
  financeTestiRole: 'Financial Services',
  financeTestiQuote: 'The Alpha Solutions solution allowed us to fully automate our client portfolio management. Standards-compliant automated reporting saves us weeks of work every month.',
  financeSatisfied: 'Satisfied client since 2021',
  financeCtaTitle: 'Ready to Modernize Your Financial Services?',
  financeCtaDesc: 'Join the financial institutions that trust us',
  financeAdv1Title: 'Guaranteed Compliance',
  financeAdv1Desc: '100% compliance with financial regulations',
  financeAdv2Title: 'Efficiency +50%',
  financeAdv2Desc: 'Improved operational efficiency',
  financeAdv3Title: 'Risk Reduction',
  financeAdv3Desc: '60% reduction in operational risks',
  financeAdv4Title: 'Optimized ROI',
  financeAdv4Desc: 'Improved return on investment',

  // Satisfied since label
  satisfiedSince: 'Satisfied client since',

  // ERP page - hardcoded advantages
  erpDeployTitle: 'Fast Deployment',
  erpDeployDesc: 'Implementation in 2-4 weeks with complete team training',
  erpSupportTitle: '24/7 Support',
  erpSupportDesc: 'Permanent technical assistance and preventive maintenance included',
  erpCustomTitle: '100% Customizable',
  erpCustomDesc: 'Full adaptation to your specific business processes',
  erpCloudTitle: 'Cloud & On-Premise',
  erpCloudDesc: 'Flexible deployment according to your security constraints',
  erpRoiTitle: 'Guaranteed ROI',
  erpRoiDesc: 'Measurable return on investment from the first months',
  erpMultiCurrTitle: 'Multi-Currency',
  erpMultiCurrDesc: 'International management with guaranteed local compliance',
  erpTestiCompany: 'Entreprise Générale du Cameroun',
  erpTestiSector: 'Industrial group - 500+ employees',
  erpTestiQuote: "The implementation of the Alpha Solutions ERP revolutionized our management. In 6 months, we automated 80% of our administrative processes and reduced operational costs by 35%. The team support was exceptional.",
  erpTestiStat1: 'Cost reduction',
  erpTestiStat2: 'Automated processes',
  erpTestiStat3: 'Return on investment',
  erpTestiPerson: 'Jean-Claude Mbarga',
  erpTestiPersonRole: 'General Manager',

  // Hotellerie - hardcoded content
  hotellerieAdv1Title: 'Major Time Savings',
  hotellerieAdv1Desc: '80% reduction in closing time (from 5h to 20 minutes)',
  hotellerieAdv2Title: 'Occupancy Optimization',
  hotellerieAdv2Desc: 'Average 30% increase in occupancy rate through revenue management',
  hotellerieAdv3Title: 'Client Satisfaction',
  hotellerieAdv3Desc: '40% improvement in satisfaction through faster and personalized service',
  hotellerieAdv4Title: 'Revenue Growth',
  hotellerieAdv4Desc: 'Average 25% revenue growth with our integrated systems',
  hotellerieAdv5Title: 'Error Reduction',
  hotellerieAdv5Desc: '85% reduction in reservation and billing errors',
  hotellerieAdv6Title: 'Complete Visibility',
  hotellerieAdv6Desc: 'Real-time dashboards to effectively manage your establishment',
  hotellerieSol1: 'Drastic reduction in closing time',
  hotellerieSol2: 'Automation of reservation processes',
  hotellerieSol3: 'Improved guest experience',
  hotellerieSol4: 'Optimized occupancy rate',
  hotellerieSol5: 'Centralized multi-channel management',
  hotellerieSol6: 'Real-time reporting for management',
  hotellerieTestiQuote: "Thanks to Alpha Solutions, our hotel complex was completely transformed. The integrated reservation system and optimized client management allowed us to increase our occupancy rate by 40% in 6 months.",
  hotellerieTestiPerson: 'Jean Michel Tchatchoua',
  hotellerieTestiRole2: 'Owner - Elabi Pool & Spa',
  hotellerieTestiSince: 'Satisfied client since 2021',

  // Immobilier sector
  immobilierHeroTitle: 'Real Estate Solutions',
  immobilierHeroDesc: 'Efficiently manage your real estate portfolio with our rental management and property tracking tools',
  immobilierSolutionsTitle: 'Our Real Estate Solutions',
  immobilierSolutionsSubtitle: 'A complete platform for optimizing your real estate portfolio management',
  immobilierWhyTitle: 'Why Choose Our Solutions?',
  immobilierTestiName: 'SCI Platinum',
  immobilierTestiRole: 'Property Management',
  immobilierTestiQuote: "The Alpha Solutions solution transformed our real estate management. Automated tenant tracking and online invoicing saved us valuable time. Our recovery rate increased by 40% in 6 months.",
  immobilierTestiSince: 'Satisfied client since 2021',
  immobilierCtaTitle: 'Ready to Optimize Your Real Estate Management?',
  immobilierCtaDesc: 'Join the real estate managers who trust us',
  immobilierAdv1Title: 'Time Savings',
  immobilierAdv1Desc: 'Automation of 80% of recurring administrative tasks',
  immobilierAdv2Title: 'Reduced Unpaid Rents',
  immobilierAdv2Desc: '60% reduction in late payments thanks to alerts',
  immobilierAdv3Title: 'Tenant Satisfaction',
  immobilierAdv3Desc: 'Improved tenant relationship with the dedicated portal',
  immobilierAdv4Title: 'Profitability Optimization',
  immobilierAdv4Desc: 'Average 15% increase in real estate profitability',
  immobilierSol1Title: 'Real Estate Portfolio Management',
  immobilierSol1Desc: 'Centralization of all your properties with detailed tracking',
  immobilierSol2Title: 'Tenant & Contract Management',
  immobilierSol2Desc: 'Complete tenant tracking and automated contract management',
  immobilierSol3Title: 'Billing & Accounting',
  immobilierSol3Desc: 'Billing automation and financial tracking',
  immobilierSol4Title: 'Maintenance & Works',
  immobilierSol4Desc: 'Planning and tracking of maintenance interventions',
  immobilierSol5Title: 'Tenant Portal',
  immobilierSol5Desc: 'Dedicated interface for your tenants',
  immobilierSol6Title: 'Analytics & Reporting',
  immobilierSol6Desc: 'Dashboards to optimize your profitability',

  // Production sector
  productionHeroTitle: 'Production & Industry Solutions',
  productionHeroDesc: 'Optimize your industrial production with our planning, quality and maintenance solutions',
  productionSolutionsTitle: 'Our Production & Industry Solutions',
  productionSolutionsSubtitle: 'A complete suite to optimize your industrial production chain',
  productionWhyTitle: 'Why Choose Our Solutions?',
  productionTestiName: 'SOFIPAC',
  productionTestiRole: 'Production & Industry',
  productionTestiQuote: "With Alpha Solutions, our production planning became fully automated. The integrated quality control allowed us to reduce defects by 80% and increase productivity by 30%.",
  productionTestiSince: 'Satisfied client since 2020',
  productionCtaTitle: 'Ready to Optimize Your Production?',
  productionCtaDesc: 'Join the industrialists who trust us for their digital transformation',
  productionAdv1Title: 'Productivity +25%',
  productionAdv1Desc: 'Average productivity increase through optimization',
  productionAdv2Title: 'Cost Reduction',
  productionAdv2Desc: '20% reduction in production and maintenance costs',
  productionAdv3Title: 'Improved Quality',
  productionAdv3Desc: '70% reduction in defects through quality control',
  productionAdv4Title: 'Total Traceability',
  productionAdv4Desc: 'Complete tracking of the production chain',
  productionSol1Title: 'Production Planning',
  productionSol1Desc: 'Optimization of production schedules with resource management',
  productionSol2Title: 'Quality Management',
  productionSol2Desc: 'Integrated quality control with complete traceability',
  productionSol3Title: 'Preventive Maintenance',
  productionSol3Desc: 'Planning and tracking of equipment maintenance',
  productionSol4Title: 'Stock Management',
  productionSol4Desc: 'Raw materials and finished products inventory',
  productionSol5Title: 'Production Costs',
  productionSol5Desc: 'Precise cost calculation and profitability analysis',
  productionSol6Title: 'Dashboards',
  productionSol6Desc: 'Real-time performance indicators',

  // Administration sector
  administrationHeroTitle: 'Public Administration Solutions',
  administrationHeroDesc: 'Modernize your public services with our citizen management and digitalization solutions',
  administrationSolutionsTitle: 'Our Public Administration Solutions',
  administrationSolutionsSubtitle: 'A complete platform for the modernization of public services',
  administrationWhyTitle: 'Why Choose Our Solutions?',
  administrationTestiName: 'Port Autonome de Douala',
  administrationTestiRole: 'Public Administration',
  administrationTestiQuote: "The digitalization of our port services with Alpha Solutions transformed our efficiency. Optimized document management and online services significantly improved our relationship with users.",
  administrationTestiSince: 'Satisfied client since 2019',
  administrationCtaTitle: 'Ready to Modernize Your Public Services?',
  administrationCtaDesc: 'Join the administrations that trust us',
  administrationAdv1Title: 'Transparency',
  administrationAdv1Desc: 'Improved transparency of public services',
  administrationAdv2Title: 'Efficiency +40%',
  administrationAdv2Desc: 'Improved efficiency of administrative services',
  administrationAdv3Title: 'Citizen Satisfaction',
  administrationAdv3Desc: 'Improved user satisfaction',
  administrationAdv4Title: 'Savings',
  administrationAdv4Desc: '30% reduction in administrative costs',
  administrationSol1Title: 'Citizen Management',
  administrationSol1Desc: 'Centralized citizen and services database',
  administrationSol2Title: 'Document Management',
  administrationSol2Desc: 'Digitalization and archiving of official documents',
  administrationSol3Title: 'Online Services',
  administrationSol3Desc: 'Digital public services portal',
  administrationSol4Title: 'Public Financial Management',
  administrationSol4Desc: 'Public accounting and budget',
  administrationSol5Title: 'Public Human Resources',
  administrationSol5Desc: 'Public service staff management',
  administrationSol6Title: 'Public Dashboards',
  administrationSol6Desc: 'Strategic management of the firm',

  // Prestataire Service sector
  prestataireHeroTitle: 'Service Provider Solutions',
  prestataireHeroDesc: 'Manage your interventions, contracts and teams with an all-in-one platform dedicated to service providers',
  prestataireSolutionsTitle: 'Our Solutions for Service Providers',
  prestataireSolutionsSubtitle: 'A complete suite to optimize your operations and satisfy your clients',
  prestataireCtaTitle: 'Ready to Digitalize Your Service Business?',
  prestataireCtaDesc: 'Join the service providers who optimize their operations with Alpha Solutions',
  prestataireSol1Title: 'Intervention Management',
  prestataireSol1Desc: 'Planning and tracking of field interventions',
  prestataireSol2Title: 'Service Provider CRM',
  prestataireSol2Desc: 'Client and service contract management',
  prestataireSol3Title: 'Billing & Quotes',
  prestataireSol3Desc: 'Fast quote and invoice generation',
  prestataireSol4Title: 'Team Management',
  prestataireSol4Desc: 'HR planning and agent management',
  prestataireSol5Title: 'Stock & Equipment',
  prestataireSol5Desc: 'Equipment and consumables management',
  prestataireSol6Title: 'Service Dashboard',
  prestataireSol6Desc: 'Global management of your service business',

  // BTP Construction sector
  btpHeroTitle: 'BTP & Construction Solutions',
  btpHeroDesc: 'Manage your construction sites, teams and costs with our dedicated BTP solutions',
  btpSolutionsTitle: 'Our BTP & Construction Solutions',
  btpSolutionsSubtitle: 'A complete platform to master every aspect of your construction projects',
  btpCtaTitle: 'Master Every Site with Precision',
  btpCtaDesc: 'Join the BTP companies that digitalize their operations with Alpha Solutions',
  btpSol1Title: 'Site Management',
  btpSol1Desc: 'Complete tracking of your construction sites',
  btpSol2Title: 'Supply Management',
  btpSol2Desc: 'Materials and purchasing control',
  btpSol3Title: 'BTP Quotes & Billing',
  btpSol3Desc: 'Precise estimation and automated billing',
  btpSol4Title: 'Site HR Management',
  btpSol4Desc: 'Worker management and time tracking',
  btpSol5Title: 'Equipment & Machinery',
  btpSol5Desc: 'Equipment fleet and maintenance management',
  btpSol6Title: 'BTP Reporting & Finance',
  btpSol6Desc: 'Financial control and BTP management',

  // RH Placement sector
  rhHeroTitle: 'HR & Recruitment Solutions',
  rhHeroDesc: 'Manage your candidates, placements and HR contracts with a platform designed for recruitment agencies and HR firms',
  rhSolutionsTitle: 'Our HR & Recruitment Solutions',
  rhSolutionsSubtitle: 'Automate your recruitment and placement process to gain efficiency',
  rhCtaTitle: 'Boost Your HR Placement Business',
  rhCtaDesc: 'Join the HR agencies that trust Alpha Solutions',
  rhSol1Title: 'Application Management',
  rhSol1Desc: 'CV processing and candidate tracking',
  rhSol2Title: 'Placements & Missions',
  rhSol2Desc: 'Temporary work mission management',
  rhSol3Title: 'HR Contract Management',
  rhSol3Desc: 'Work contracts and outsourced payroll',
  rhSol4Title: 'Corporate Client Portal',
  rhSol4Desc: 'Dedicated interface for your corporate clients',
  rhSol5Title: 'Training & Skills',
  rhSol5Desc: 'Training management and skills development',
  rhSol6Title: 'HR Reporting',
  rhSol6Desc: 'Analytics and statistics of your HR activity',

  // Cabinets Conseil sector
  cabinetsHeroTitle: 'Consulting Firm Solutions',
  cabinetsHeroDesc: 'Manage your missions, consultants and clients with a platform designed for consulting and audit firms',
  cabinetsSolutionsTitle: 'Our Solutions for Consulting Firms',
  cabinetsSolutionsSubtitle: 'Optimize your firm management and improve the profitability of your missions',
  cabinetsCtaTitle: 'Elevate the Performance of Your Firm',
  cabinetsCtaDesc: 'Join the consulting firms that modernize their management with Alpha Solutions',
  cabinetsSol1Title: 'Mission Management',
  cabinetsSol1Desc: 'Tracking of consulting missions and projects',
  cabinetsSol2Title: 'CRM & Business Development',
  cabinetsSol2Desc: 'Client acquisition and retention',
  cabinetsSol3Title: 'Time Billing',
  cabinetsSol3Desc: 'Billing based on time spent',
  cabinetsSol4Title: 'Document Management',
  cabinetsSol4Desc: 'Centralization of documents and reports',
  cabinetsSol5Title: 'Consultant Management',
  cabinetsSol5Desc: 'Planning and resource allocation',
  cabinetsSol6Title: 'Executive Dashboard',
  cabinetsSol6Desc: 'Strategic management of the firm',

  // Video Surveillance sector
  videoHeroTitle: 'Video Surveillance & Security',
  videoHeroDesc: 'Protect your premises, control access and supervise remotely with our intelligent security solutions',
  videoSolutionsTitle: 'Our Security & Surveillance Solutions',
  videoSolutionsSubtitle: 'Robust and intelligent systems for total protection of your assets',
  videoCtaTitle: 'Secure Your Business Now',
  videoCtaDesc: 'Free security audit — our experts assess your needs and propose an adapted solution',
  videoCtaBtn: 'Free Audit',
  videoSol1Title: 'IP Video Surveillance',
  videoSol1Desc: 'High-resolution intelligent camera systems',
  videoSol2Title: 'Access Control',
  videoSol2Desc: 'Intelligent access and entry management',
  videoSol3Title: 'Biometrics & Time Tracking',
  videoSol3Desc: 'Reliable biometric time tracking system',
  videoSol4Title: 'Recording & Storage',
  videoSol4Desc: 'Secure archiving of images and videos',
  videoSol5Title: 'Remote Supervision',
  videoSol5Desc: 'Centralized multi-site monitoring',
  videoSol6Title: 'Intercom & Barriers',
  videoSol6Desc: 'Physical access control and intercom',

  // Atelier Garage sector
  atelierHeroTitle: 'Workshop & Garage Solutions',
  atelierHeroDesc: 'Manage your repair orders, parts inventory and workshop scheduling with a solution dedicated to garages and auto centers',
  atelierSolutionsTitle: 'Our Workshop & Garage Solutions',
  atelierSolutionsSubtitle: 'Everything your garage needs to optimize its business and satisfy your clients',
  atelierCtaTitle: 'Modernize Your Workshop Today',
  atelierCtaDesc: 'Dozens of garages trust Alpha Solutions for their daily management',
  atelierSol1Title: 'Repair Orders',
  atelierSol1Desc: 'Complete management of mechanical interventions',
  atelierSol2Title: 'Parts Management',
  atelierSol2Desc: 'Spare parts and consumables stock',
  atelierSol3Title: 'Client Vehicle Management',
  atelierSol3Desc: 'Complete history per vehicle',
  atelierSol4Title: 'Billing & Cash',
  atelierSol4Desc: 'Workshop billing and cash management',
  atelierSol5Title: 'Workshop Scheduling',
  atelierSol5Desc: 'Slot organization and mechanic management',
  atelierSol6Title: 'Garage Dashboards',
  atelierSol6Desc: 'Garage performance management',

  // Bulk SMS sector
  bulkSmsHeroTitle: 'Bulk SMS & WhatsApp Business',
  bulkSmsHeroDesc: 'Instantly reach your clients with massive SMS and WhatsApp campaigns — marketing, OTP, alerts and automation',
  bulkSmsSolutionsTitle: 'Our Bulk SMS & WhatsApp Solutions',
  bulkSmsSolutionsSubtitle: 'A complete platform for all your mass digital communications',
  bulkSmsCtaTitle: 'Launch Your First Campaign Today',
  bulkSmsCtaDesc: 'Free trial — test the platform with 100 complimentary SMS, no commitment',
  bulkSmsCtaBtn: 'Start for Free',
  bulkSmsFreeTrial: 'Free Trial',
  bulkSmsStat1Label: 'SMS delivery rate',
  bulkSmsStat2Label: 'Average sending delay',
  bulkSmsStat3Label: 'SMS sent/month',
  bulkSmsStat4Label: 'Platform availability',
  bulkSmsSol1Title: 'Bulk SMS',
  bulkSmsSol1Desc: 'Mass SMS sending to your contacts',
  bulkSmsSol2Title: 'WhatsApp Business API',
  bulkSmsSol2Desc: 'Professional WhatsApp campaigns',
  bulkSmsSol3Title: 'WhatsApp Chatbot',
  bulkSmsSol3Desc: 'WhatsApp response automation',
  bulkSmsSol4Title: 'SMS OTP & Security',
  bulkSmsSol4Desc: 'Authentication and verification codes',
  bulkSmsSol5Title: 'Automated Marketing',
  bulkSmsSol5Desc: 'Marketing campaigns and loyalty',
  bulkSmsSol6Title: 'Reports & Analytics',
  bulkSmsSol6Desc: 'Campaign performance analysis',
}
